module.exports = __webpack_public_path__ + "img/will-additional.1e62f2fa.svg";